<template>
  <div class="connect">
    <ComponentHeader v-bind:index="index" />

    <div id="image" class="image">
      <div>CONNECT US</div>
      <div>联系我们</div>
    </div>

    <section>
      <el-row class="block">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bt"
          >联系我们</el-col
        >

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" id="map">
          <div id="allmap"></div>
        </el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="content">
          <div class="lxfs">
            <div class="title">联系方式</div>
            <div class="line"></div>
            <div class="detail">
              <span>电话：18083721326</span>
              <span class="center">座机：0523-81559299</span>
              <span>邮箱:57970814@qq.com</span>
            </div>
          </div>
        </el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="content">
          <div class="dz">
            <div class="title">地址</div>
            <div class="line"></div>
            <div class="detail">
              <span>江苏省泰州市高港区港城西路3号</span>
            </div>
          </div>
        </el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="content">
          <div class="zxpt">
            <div class="title">资讯平台</div>
            <div class="line"></div>
            <div class="detail">
              <div class="title">
                <span>微信搜索“峰润洗涤”</span>
                <span>关注我们</span>
              </div>
              <div class="qcode"></div>
            </div>
          </div>
        </el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="btn">
          <button @click="back">返回</button>
        </el-col>
      </el-row>
    </section>

    <ComponentFooter />
  </div>
</template>

<script>
import "../ui/ui.js";
import ComponentFooter from "../components/Footer.vue";
import ComponentHeader from "../components/Header.vue";

export default {
  name: "Home",
  components: { ComponentFooter, ComponentHeader },
  data() {
    return {
      index: "5",
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
  mounted() {
    // let divEle = document.querySelector(".container");
    // var map = new BMap.Map("allmap");
    // map.centerAndZoom(new BMapGL.Point(116.28019, 40.049191), 19);
    // let map = new BMap.Map(divEle);
    // let point = new BMap.Point(119.871872, 32.322677);
    // map.centerAndZoom(point, 17);

    // var map = new BMap.Map("allmap"); // 创建Map实例
    // map.centerAndZoom(new BMap.Point(119.871872, 32.322677), 20); // 初始化地图,设置中心点坐标和地图级别
    // map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    // map.setHeading(64.5);
    // map.setTilt(73);

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    document.getElementById("map").style.width = width * 0.8 + "px";
  },
};
</script>

<style lang="less" scoped>
.connect {
  height: 100%;
  .el-row {
    margin: 0 !important;
  }
  .image {
    width: 100%;
    background: url("../assets/image/1-01-01.png") no-repeat;
    background-size: 100% 100%;
    height: 3.2rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    div {
      color: #d2f9e9;
      font-weight: 400;
      &:first-child {
        font-size: 0.18rem;
      }
      &:last-child {
        font-size: 0.15rem;
      }
    }
  }
  section {
    // margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .block {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
      .bt {
        font-size: 0.15rem;
        font-weight: bold;
        margin: 22px 0 20px 0;
      }
      #map {
        width: 100%;
        display: flex;
        justify-content: center;
        #allmap {
          // width: 80%;
          width: 3.71rem;
          background: url("../assets/image/map.png") no-repeat;
          background-size: 100% 100%;
          height: 2.5rem;
        }
      }
      .content {
        text-align: left;
        display: flex;
        justify-content: center;
        .lxfs,
        .dz,
        .zxpt {
          margin-top: 20px;
          // width: 80%;
          width: 3.71rem;
          .title {
            font-size: 0.1rem;
            font-weight: bold;
            width: 100%;
            color: #1f948d;
            span {
              display: block;
            }
          }
          .line {
            width: 100%;
            height: 2px;
            background: #1f948d;
          }
          .detail {
            font-size: 0.07rem;
            margin-top: 10px;
            .center {
              margin: 0 0.1rem;
            }
          }
        }
        .zxpt {
          .detail {
            display: flex;
            justify-content: flex-start;
            .title {
              // margin-top: 10px;
              font-size: 0.07rem;
              color: #000;
              font-weight: 400;
              width: 150px;
              display: flex;
              justify-content: center;
              align-items: flex-start;
              flex-direction: column;
              span {
                text-align: left;
                &:first-child {
                  display: inline-block;
                  margin-bottom: 15px;
                }
              }
            }
            .qcode {
              width: 1rem;
              height: 1rem;
              background: url("../assets/image/qcode.jpg") no-repeat;
              background-size: 107% 100%;
            }
          }
        }
        .dz,
        .zxpt {
          margin-top: 20px;
        }
      }
      .btn {
        font-size: 0.7rem;
        margin: 25px 0 22px 0;
        button {
          width: 82px;
          height: 33px;
          background: #e6fffb;
          color: #000;
          border-radius: 30px;
          border-radius: 0.15rem;
          outline: 0;
          border: 0;
        }
      }
    }
  }
}
</style>